// loader.service.ts
import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private loading = new BehaviorSubject<boolean>(false);
    private message = new BehaviorSubject<string>('Loading...');

    loading$ = this.loading.asObservable();
    message$ = this.message.asObservable();

    show(message: string = 'Loading...') {
        this.message.next(message);
        this.loading.next(true);
    }

    hide() {
        this.loading.next(false);
    }
}